import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/useUserStore";
import { ILanguageSelectorProps } from "@faire/web--source/ui/LanguageSelector/common";
import React, { lazy } from "react";

const _LazyHeaderLanguageSelector = lazy(() =>
  import(
    /* webpackChunkName: "header-language-dropdown" */ "@faire/retailer-visitor-shared/components/Header/desktop/HeaderLanguageSelector/HeaderLanguageSelector"
  ).then((m) => ({ default: m.HeaderLanguageSelector }))
);
export const LazyHeaderLanguageSelector = (
  props: Omit<ILanguageSelectorProps, "userToken">
) => {
  const { isImpersonating } = useUserStore();
  const { userToken } = useUserStore(["userToken"]);

  return (
    <_LazyHeaderLanguageSelector
      {...props}
      userToken={isImpersonating ? undefined : userToken}
    />
  );
};
